<template>
    <div id="app">
        <header>
            <h1>Tech Birthday</h1>
            <p>Know when to celebrate the birthday of your favorite tech tool</p>
            <input
                    id="search"
                    type="text"
                    placeholder="search"
                    v-model="search"
            >
        </header>
        <div id="content">
            <block
                    v-for="(item, index) in tools"
                    :key="index"
                    :name="item.name"
                    :url="item.url"
                    :created="item.created"
                    :backgroundColor="item.backgroundColor"
                    :color="item.color"
            />
        </div>
    </div>
</template>

<script>
    import Block from './components/Block.vue';
    import tech from './assets/tech.json';

    export default {
        name: 'app',
        components: {
            Block
        },
        data() {
            return {
                data: [],
                search: ""
            };
        },
        created() {
            this.data = tech.tools;
        },
        computed: {
            tools() {
                if (this.search.length > 0) {
                    const matches = [];

                    this.data.forEach((val) => {
                        if (val.name.toLowerCase().includes(this.search.toLowerCase())) {
                            matches.push(val);
                        }
                    });

                    return matches;
                } else {
                    return this.data;
                }
            }
        }
    };
</script>

<style>
    body,
    html {
        margin: 0;
        padding: 0;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }

    header {
        padding: 50px;
        color: white;
        background-color: black;
        height: 250px;
        text-align: center;
    }

    header #search {
        text-align: center;
        margin-top: 30px;
        border-radius: 25px;
        border: 0;
        padding: 10px;
        width: 300px;
        font-size: 22px;
    }

    header #search:focus {
        outline: 0;
    }

    #content {
        display: grid;
        grid-template-columns: auto auto auto auto;
    }

    @media only screen and (max-width: 980px) {
        #content {
            grid-template-columns: auto auto auto;
        }
    }

    @media only screen and (max-width: 880px) {
        #content {
            grid-template-columns: auto auto;
        }
    }

    @media only screen and (max-width: 600px) {
        #content {
            grid-template-columns: auto;
        }
    }
</style>
